import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { getFormattedDateTime } from 'ecs-react-components/dist/index.es';
import { Card } from 'react-bootstrap';

import NewQuestionnaireButton from './NewQuestionnaireButton';
import { messages } from './Questionnaires.i18n';

export class QuestionnaireCard extends React.Component {
  renderDate(date) {
    const dateClass = moment(date).isSameOrAfter(moment(), 'day') ? 'date' : 'date overdue';
    const buttonText = moment(date).isSameOrAfter(moment(), 'day')
      ? <FormattedMessage { ...messages.date.due } />
      : <FormattedMessage { ...messages.date.overdue } />;
    const formattedDate = getFormattedDateTime(date, date, this.props.language);
    return (<span className={dateClass}>{buttonText} {formattedDate.datePart}</span>);
  }

  render() {
    const indicatorCss = 'fa fa-circle new-indicator me-1' + (this.props.item.dueDate !== null ? '' : ' hidden');
    const colClass = this.props.colCssClass || 'col-lg-6 col-12';
    return (
      <div key={ this.props.item.assignedQuestionnaireId }>
        <div className="row mb-3">
          <div className={colClass}>
            <div data-qa-item={ this.props.item.assignedQuestionnaireId }
              className="panel panel-default description-box px-0"
            >
              <Card bg="white">
                <Card.Body className="new-indicator-padding-left">
                  <NewQuestionnaireButton
                    assignedQuestionnaireId={ this.props.item.assignedQuestionnaireId }
                    hideDecline={this.props.hideDecline}
                  />

                  <p>
                    <span className={ indicatorCss }></span>
                    <span className="title">{this.props.item.templateTitle}</span>
                    <br />
                    {this.renderDate(this.props.item.dueDate)}
                  </p>
                  <p>{this.props.item.templateDescription}</p>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

QuestionnaireCard.propTypes = {
  item: PropTypes.object,
  language: PropTypes.string,
  hideDecline: PropTypes.bool,
  colCssClass: PropTypes.string,
};